import { MoveLeft } from 'lucide-react'
import { useNavigate } from 'react-router'
import Button from '../ui/button/Button'
import Tooltip from './Tooltip'

const BackButton = ({ isIconOnly }: { isIconOnly?: boolean }) => {
    const navigate = useNavigate()

    return (
        <Tooltip label='Voltar'>
            <Button
                onClick={() => navigate(-1)}
                variant='link'
                startIcon={!isIconOnly && <MoveLeft className='w-4 h-4' />}
                className='hover:underline '
            >
                {isIconOnly ? <MoveLeft className='w-4 h-4' /> : 'Voltar'}
            </Button>
        </Tooltip>
    )
}

export default BackButton
